import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

export type EpicType = 'seasonal' | 'performance' | 'feedback_session' | 'dtalk' | 'talent_map';

// La etiqueta se guarda como clave y se traduce en el componente: `t` no existe a nivel de módulo.
const TYPE_CONFIG: Record<EpicType, { labelKey: string; style: string }> = {
  seasonal:         { labelKey: 'performance.epic_type_badge.seasonal',         style: 'bg-violet-100 text-violet-700 border-violet-200' },
  performance:      { labelKey: 'performance.epic_type_badge.performance',      style: 'bg-red-100 text-red-700 border-red-200' },
  dtalk:            { labelKey: 'performance.epic_type_badge.dtalk',            style: 'bg-amber-100 text-amber-700 border-amber-200' },
  talent_map:       { labelKey: 'performance.epic_type_badge.talent_map',       style: 'bg-teal-100 text-teal-700 border-teal-200' },
  feedback_session: { labelKey: 'performance.epic_type_badge.feedback_session', style: 'bg-gray-100 text-gray-600 border-gray-200' },
};

interface EpicTypeBadgeProps {
  type: string;
  className?: string;
}

export function EpicTypeBadge({ type, className }: EpicTypeBadgeProps) {
  const { t } = useTranslation();
  const cfg = TYPE_CONFIG[type as EpicType] ?? TYPE_CONFIG.seasonal;
  return (
    <span className={cn('inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold tracking-wide uppercase', cfg.style, className)}>
      {t(cfg.labelKey)}
    </span>
  );
}
